"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.audioVideoDidStartConnectingHandler = audioVideoDidStartConnectingHandler;
var _logger = require("@studio/logger");
var _constants = require("../../../constants");
function audioVideoDidStartConnectingHandler(reconnectingStatus, meetingResponse, attendeeResponse) {
  // Log attendee connection status
  var meetingId = meetingResponse.Meeting.MeetingId;
  var attendeeId = attendeeResponse.Attendee.AttendeeId;
  var logPayload = {
    chimeEventName: 'audioVideoDidStartConnecting',
    'studio.meeting.id': meetingId,
    title: "Audio-Video is ".concat(reconnectingStatus ? 'reconnecting' : 'connecting', " for attendee ").concat(attendeeId, " in meeting ").concat(meetingId)
  };
  (0, _logger.sendToDatadog)(_constants.loggerName, logPayload, logPayload.title, false);
}